<template>
  <div>
      <img class="img-box" v-if="type=='email'" src="../../assets/down/ydj-email.jpg">
      <img class="img-box" v-else-if="type=='pcydj'" src="../../assets/down/pc-ydj.jpg">
  </div>
</template>
<script>
export default {
  data() {
    return {
      type: this.$route.params.type,
    };
  },
  created() {
  }
};
</script>
<style lang="scss" scoped>
.img-box{
    display:block;
    width:100%;
    max-width: 1200px;
    margin:0 auto;
}
</style>
